export * from './PaymentProtectionBadge';
